// Función para detectar el formato de imagen disponible
export const getImageSrc = (index) => {
  const formats = ['jpg', 'jpeg', 'png', 'JPG', 'JPEG', 'PNG'];
  
  for (const format of formats) {
    try {
      return require(`../assets/${index}.${format}`);
    } catch (error) {
      // Continúa con el siguiente formato
      continue;
    }
  }
  
  // Si no encuentra ningún formato, devuelve null o una imagen por defecto
  console.warn(`No image found for index ${index}`);
  return null;
};

// Función para generar array de imágenes del portfolio
export const generatePortfolioImages = (count = 34) => {
  const images = [];
  
  for (let i = 1; i <= count; i++) {
    const src = getImageSrc(i);
    if (src) {
      images.push({
        src,
        alt: `Portfolio piece ${i}`,
        id: i
      });
    }
  }
  
  return images;
};

// Función para precargar todas las imágenes
export const preloadAllImages = async (count = 34) => {
  const imagePromises = [];
  
  for (let i = 1; i <= count; i++) {
    const src = getImageSrc(i);
    if (src) {
      const promise = new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = resolve;
        img.onerror = reject;
        img.src = src;
      });
      imagePromises.push(promise);
    }
  }
  
  return Promise.all(imagePromises);
};